/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Dangerzonedescription_Delete3Inputs */

const zh_organizationsettings_dangerzonedescription_delete3 = /** @type {(inputs: Organizationsettings_Dangerzonedescription_Delete3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除组织后，所有成员将失去访问权限，所有数据将被永久删除。`)
};

const en_organizationsettings_dangerzonedescription_delete3 = /** @type {(inputs: Organizationsettings_Dangerzonedescription_Delete3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting the organization will remove all members and permanently delete all data.`)
};

const es_organizationsettings_dangerzonedescription_delete3 = /** @type {(inputs: Organizationsettings_Dangerzonedescription_Delete3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar la organización eliminará a todos los miembros y borrará permanentemente todos los datos.`)
};

/**
* | output |
* | --- |
* | "Deleting the organization will remove all members and permanently delete all data." |
*
* @param {Organizationsettings_Dangerzonedescription_Delete3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_dangerzonedescription_delete3 = /** @type {((inputs?: Organizationsettings_Dangerzonedescription_Delete3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Dangerzonedescription_Delete3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_dangerzonedescription_delete3(inputs)
	if (locale === "en") return en_organizationsettings_dangerzonedescription_delete3(inputs)
	return es_organizationsettings_dangerzonedescription_delete3(inputs)
});
export { organizationsettings_dangerzonedescription_delete3 as "organizationSettings_dangerZoneDescription_delete" }